import { lazyGetItemProperties } from 'owa-get-item-manager';
import { featureId, MESSAGE_CARD_PROPERTY_NAME } from './messageCardItemPropertyEntry';
import { ClientItem } from 'owa-mail-store';
import Item from 'owa-service/lib/contract/Item';
import { CardDetails } from 'owa-actionable-message';
import setCardDetailsOnItem from '../actions/setCardDetailsOnItem';
import getExtendedPropertyValue from 'owa-mail-store/lib/utils/getExtendedPropertyValue';
import { trace } from 'owa-trace';
import parseCardProperty from './parseCardProperty';

export default async function initCardDetailsOnItem(item: ClientItem) {
    const cardDetails = (await loadCardDetailsForItem(item)) || [];
    if (!item.adaptiveCardDetails || item.adaptiveCardDetails.length === 0) {
        trace.info('[MessageCardDebug] initCardDetailsOnItem: setting card details on item');
        setCardDetailsOnItem(item, cardDetails);
    } else {
        trace.info('[MessageCardDebug] initCardDetailsOnItem: not replacing existing details');
    }
}

async function loadCardDetailsForItem(item: ClientItem): Promise<CardDetails[]> {
    let updatedItem: Item = null;

    try {
        const getItemProperties = await lazyGetItemProperties.import();
        updatedItem = await getItemProperties(item.ItemId.Id, featureId);
    } catch (e) {
        // On a network error we just won't have a card for this item
    }

    if (updatedItem) {
        let extendedPropertyValue = getExtendedPropertyValue(
            updatedItem,
            null /* tag */,
            MESSAGE_CARD_PROPERTY_NAME
        );
        if (extendedPropertyValue) {
            return await parseCardProperty(extendedPropertyValue);
        } else {
            trace.info('[loadCardDetailsForItem] extendedProperty could not be retrieved');
            return null;
        }
    }

    return null;
}
